<script setup lang="ts">
import { useMessage } from 'naive-ui'
import { GlobalThis } from '@/utils'

GlobalThis.$message = useMessage()
</script>

<template>
  <slot />
</template>
